import { create } from 'zustand';

const useStockStore = create((set) => ({
  // StockAdjustModal — hangi ürün için açık
  adjustingProduct: null, // { id, name, stockQty, unit }
  openAdjust: (product) => set({ adjustingProduct: product }),
  closeAdjust: () => set({ adjustingProduct: null }),
}));

export default useStockStore;
